const replaceWithMarkup = (str: string, secondColor = 'text-green-900') => {
  return str
    .replace(/\|/g, `<br class="block" />`)
    .replace(/\*\*(.*?)\*\*/g, `<span class="${secondColor}">$1</span>`)
}

export { replaceWithMarkup }
